import { ref } from 'vue';
import Request from '@/services/request';
import { EARLY_SETTLEMENT_AVAILABILITY } from '@/utils/enum/endpoints';

const Req = new Request();

export default function useEarlySettlementAvailability() {
  const data = ref(null);
  const error = ref(null);
  const isLoading = ref(false);

  const fetchAvailability = async () => {
    isLoading.value = true;

    try {
      const response = await Req.get(EARLY_SETTLEMENT_AVAILABILITY, null, {
        baseURL: '/sellerofficeapi/rest',
        headers: { Accept: 'application/json' },
      });

      if (response.status === 200) {
        data.value = response.data;
        error.value = null;
      }
    } catch (err) {
      error.value = err || null;
      data.value = null;
    } finally {
      isLoading.value = false;
    }
  };

  return {
    data,
    error,
    isLoading,
    fetchAvailability,
  };
}

